export const SELECT_LANGUAGE_ACTION = 'SELECT_LANGUAGE_ACTION';
export const SELECT_LANGUAGE_SUCCESS_ACTION = 'SELECT_LANGUAGE_SUCCESS_ACTION';
export const SELECT_LANGUAGE_FAILURE_ACTION = 'SELECT_LANGUAGE_FAILURE_ACTION';
